import React from "react";
import PropTypes from "prop-types";
import { Tabs as MUITabs, Stack, Tab } from "@mui/material";
import styles from "./styles";
import { colors } from "../../utils";

const Tabs = ({
  categories,
  selectedCategory,
  onCategoryChange,
  color = "#81459B",
  indicatorColor = "#C283DA",
  tabStyle,
  disabledCategories = [],
  categoriesWithIcons = [],
  variant = "fullWidth",
  suffixStyle = {},
  sx = {},
}) => {
  const classes = styles(color, indicatorColor);

  const renderTabs = () => {
    if (categoriesWithIcons.length > 0) {
      return categoriesWithIcons.map(
        ({ label, value, icon, suffix, customIcon }) => (
          <Tab
            key={value}
            label={
              <Stack alignItems={"center"} gap={1} direction={"row"}>
                {/* <img style={{color:'red',fill:'red',stroke:'red'}} width={20} height={20} alt={icon} src={icon}></img> */}
                {!!icon &&
                  React.cloneElement(icon, {
                    width: 20,
                    height: 20,
                    fill:
                      selectedCategory === value
                        ? colors.PrimaryPurple
                        : colors.lightGrey,
                  })}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "DM Sans",
                    fontSize: 14,
                    fontWeight: 400,
                    color:
                      selectedCategory === value
                        ? colors.PrimaryPurple
                        : colors.lightGrey,
                  }}
                >
                  {label}
                </div>
                {!!suffix && (
                  <div
                    style={{
                      borderRadius: 50,
                      padding: "2px 10px",
                      backgroundColor:
                        selectedCategory === value ? "#EFE9FE" : "#ECECEC",
                      ...suffixStyle,
                    }}
                  >
                    <div
                      style={{
                        alignItems: "center",
                        fontFamily: "DM Sans",
                        fontSize: 12,
                        color:
                          selectedCategory === value
                            ? colors.PrimaryPurple
                            : "inherit",
                      }}
                    >
                      {suffix}
                    </div>
                  </div>
                )}

                {!!customIcon && customIcon}
              </Stack>
            }
            value={value}
            sx={{
              ...classes.tabLabel,
              transition: "background-color 0.2s ease",
              "&:hover": {
                backgroundColor: "#EFE9FE !important",
              },
            }}
            style={{
              ...tabStyle,
              transition: "background-color 0.2s ease",
              "&:hover": {
                backgroundColor: "#EFE9FE !important",
              },
            }}
            disabled={disabledCategories.includes(value)}
          />
        )
      );
    }

    return categories.map((category) => (
      <Tab
        key={category}
        label={category}
        value={category}
        sx={{
          ...classes.tabLabel,
          transition: "background-color 0.2s ease",
          "&:hover": {
            backgroundColor: "#EFE9FE !important",
          },
        }}
        style={{
          ...tabStyle,
          transition: "background-color 0.2s ease",
          "&:hover": {
            backgroundColor: "#EFE9FE !important",
          },
        }}
        disabled={disabledCategories.includes(category)}
      />
    ));
  };

  return (
    <MUITabs
      value={selectedCategory}
      onChange={onCategoryChange}
      variant={variant}
      TabIndicatorProps={{
        style: classes.tabContainer,
      }}
      sx={{
        minHeight: "auto",
        "& .MuiTab-root": {
          minWidth: "auto",
          padding: "8px 12px",
          fontSize: "13px",
          fontWeight: 500,
        },
        "& .MuiTabs-flexContainer": {
          gap: "4px",
        },
        ...sx,
      }}
    >
      {renderTabs()}
    </MUITabs>
  );
};

Tabs.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string), // Array of category strings
  selectedCategory: PropTypes.string, // Currently selected category
  onCategoryChange: PropTypes.func.isRequired, // Function to handle tab change
  color: PropTypes.string, // Custom color for the tabs
  indicatorColor: PropTypes.string, // Custom indicator color
  tabStyle: PropTypes.object, // Style object for individual tabs
  disabledCategories: PropTypes.arrayOf(PropTypes.string), // Categories to disable
  categoriesWithIcons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired, // Tab label
      value: PropTypes.string.isRequired, // Tab value
      icon: PropTypes.element, // Icon for the tab
    })
  ), // Array of category objects with icons
};

Tabs.defaultProps = {
  categories: [],
  selectedCategory: "",
  color: "#81459B",
  indicatorColor: "#C283DA",
  tabStyle: null,
  disabledCategories: [],
  categoriesWithIcons: [],
};

export default Tabs;
